export function getCategoryPathFromItem(item) {
  var _item$data, _item$data$groups;

  var group = (_item$data = item.data) === null || _item$data === void 0 ? void 0 : (_item$data$groups = _item$data.groups) === null || _item$data$groups === void 0 ? void 0 : _item$data$groups.find(function (group) {
    return group.group_id === item.groupId;
  });
  var path = group ? "".concat(group.path.replace("/all/", ""), "/").concat(group.group_id) : item.groupId;
  return path;
}